t = require('views/internal/teacup-with-helpers')('org_pref_restriction')

module.exports = ->
  t.li ->
    t.text t.mustacheVar('restriction')
    t.a '.dark-hover.js-restricted-address', { href: '#', 'data-pattern': t.mustacheVar('restriction') }, ->
      t.icon 'close', { class: 'option close' }



// WEBPACK FOOTER //
// ./app/scripts/views/templates/org_pref_restriction.coffee